"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _alloyReactLocale = require("@adsk/alloy-react-locale");
var translations = _interopRequireWildcard(require("../locales"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useTranslation = () => (0, _alloyReactLocale.useLocale)(getCurrentLocale);
const getCurrentLocale = () => {
  const userLocale = navigator.userLanguage || navigator.language;
  const formattedLocale = replaceHyphen(userLocale);
  const locale = negotiateLocale(formattedLocale);
  return translations[locale] || translations['en'];
};
const findSupportedLocale = localeCode => translations.SUPPORTED_LOCALE_CODES.find(supportedLocale => supportedLocale === localeCode);
const getLanguageCode = localeCode => localeCode.split('_')[0];
const negotiateLocale = localeCode => findSupportedLocale(localeCode) || getLanguageCode(localeCode);
const replaceHyphen = localeCode => localeCode.replace(/-/, '_');
var _default = exports.default = useTranslation;